document.addEventListener("DOMContentLoaded", function () {
  const careWrapper = document.getElementById("variant-care-wrapper");

  if (!careWrapper) {
      return;
  }

  function updateCareInstructions(variantId) {
    const allCareBlocks = careWrapper.querySelectorAll(".variant-care-content");
    allCareBlocks.forEach(block => {
      block.style.display = block.dataset.variantId === variantId ? "block" : "none";
    });
  }

  // ✅ Prevent duplicate event listeners
  if (!window.__careInstructionsListenerAdded) {
    document.addEventListener("variant:updated", function (e) {
      const newVariantId = e.detail?.variantId || window.CurrentVariant?.id;
      if (newVariantId) {
        updateCareInstructions(newVariantId);
       }
    });
    window.__careInstructionsListenerAdded = true;
  }

  // 🟡 Fallback: on initial page load
  if (window.CurrentVariant?.id) {
    updateCareInstructions(window.CurrentVariant.id);
    }
});
